import React, { useState } from "react";
import { Outlet, Route, Routes, useLocation } from "react-router-dom";
import Footer from "components/Footer/Footer.js";
import Sidebar from "components/Sidebar/SidebarInterpreter";
import Header from "components/Navbars/InterpreterNavbar";
import { AppointmentRoutes } from "views-interpreters/AppointmentList";
import routesInterpreters from "routes-interpreter";
import { BillingualRoutes } from "views/BillingualRequests";
import ImpersonationBanner from "components/common/ImpersonationBanner";

function InterpreterLayout(props) {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const mainPanel = React.useRef();
  const location = useLocation();

  React.useEffect(() => {
    mainPanel.current.scrollTop = 0;
    document.scrollingElement.scrollTop = 0;
  }, [location]);

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  return (
    <div className="wrapper">
      <ImpersonationBanner />
      <Sidebar
        {...props}
        routes={routesInterpreters}
        isSidebarOpen={isSidebarOpen}
        toggleSidebar={toggleSidebar}
      />
      <div className={`main-panel ${isSidebarOpen ? "collaped" : ""}`} ref={mainPanel}>
        <Header {...props} toggleSidebar={toggleSidebar} />
        <Routes>
          {routesInterpreters.map((prop, key) => {
            return (
              <Route
                path={prop.path}
                element={prop.component}
                key={key}
              />
            );
          })}

          <Route path="/appointments/*" element={<AppointmentRoutes />} />
          <Route path="/billingual-requests/*" element={<BillingualRoutes />} />
        </Routes>
        <Footer fluid />
      </div>
      <Outlet />
    </div>
  );
}

export default InterpreterLayout;
